import React from 'react';

import { Modal } from '@vimeo/bifrost/legacy';
import { Button, TextArea, CopyField } from '@vimeo/iris/components';

import { Captcha } from './Captcha';
import { T } from './constants';
import { EmailValidation } from './EmailValidation';
import {
  ButtonsWrapper,
  ButtonMargin,
  CopyFieldWrapper,
  MessageFieldWrapper,
  ModalContentWrapper,
} from './Styles';

interface Props {
  card?: React.ReactNode;
  link?: string;
  enableSubmit: boolean;
  showModal: boolean;
  loading: boolean;
  hasExceededCount: boolean;
  exceededCount: number;
  captchaResToken: string;
  reCaptchaSiteKey: string;
  emails: string[];
  messageInputValue: string;
  hideShareByEmail?: boolean;
  trackCopy: () => void;
  trackAddEmail?: () => void;
  removeEmail: (index: number) => void;
  closeModal: () => void;
  handleCaptcha: (res: string) => void;
  handleSubmit: (token: string) => void;
  handleCaptchaExpire: () => void;
  handleMessageInput: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  updateEmailArray: (s: string) => void;
}

export const ShareModal: React.FC<Props> = ({
  card = null,
  link,
  enableSubmit,
  closeModal,
  showModal,
  loading,
  hasExceededCount,
  exceededCount,
  captchaResToken,
  reCaptchaSiteKey,
  emails,
  messageInputValue,
  removeEmail,
  trackCopy,
  trackAddEmail,
  handleCaptcha,
  handleSubmit,
  handleCaptchaExpire,
  handleMessageInput,
  updateEmailArray,
  hideShareByEmail,
}) => {
  return (
    <Modal
      modalLabelId="shareModal"
      modalDescriptionId="Share a clip to multiple users via email"
      firstFocusSelector="No first focus"
      modalCloseLabel="Close this dialog."
      modalTitle={T.Share}
      onDismiss={closeModal}
      dismissButtonFormat="dark"
      isShowing={showModal}
      size="fluid"
    >
      <ModalContentWrapper>
        {card}
        {hideShareByEmail ? (
          <CopyField
            id="copyClipUri"
            label={T.CopyLink}
            messages={{ success: T.Copied }}
            value={link}
            onCopy={trackCopy}
          />
        ) : (
          <CopyFieldWrapper>
            <CopyField
              id="copyClipUri"
              label={T.CopyLink}
              messages={{ success: T.Copied }}
              value={link}
              onCopy={trackCopy}
            />
          </CopyFieldWrapper>
        )}
        {!hideShareByEmail && (
          <div>
            <EmailValidation
              emails={emails}
              removeEmail={removeEmail}
              updateEmailArray={updateEmailArray}
              onAddEmail={trackAddEmail}
            />
            <MessageFieldWrapper>
              <TextArea
                name="shareMsg"
                id="msg1"
                label={T.OptionalMsg}
                format={hasExceededCount ? 'negative' : 'neutral'}
                errorMsg={
                  (hasExceededCount && <span>{`- ${exceededCount} ${T.Characters}`}</span>) ||
                  undefined
                }
                defaultValue={messageInputValue}
                // @ts-ignore mismatched types
                onChange={handleMessageInput}
              />
            </MessageFieldWrapper>
            <Captcha
              recaptchaSiteKey={reCaptchaSiteKey}
              handleCaptcha={handleCaptcha}
              handleCaptchaExpire={handleCaptchaExpire}
            />
            <ButtonsWrapper>
              <ButtonMargin format="secondary" onClick={closeModal}>
                {T.Cancel}
              </ButtonMargin>
              <Button
                format="primary"
                disabled={!enableSubmit}
                loading={loading}
                onClick={() => handleSubmit(captchaResToken)}
              >
                {T.Send}
              </Button>
            </ButtonsWrapper>
          </div>
        )}
      </ModalContentWrapper>
    </Modal>
  );
};
